import { useQuery } from '@tanstack/react-query';
import fetch from './fetch';

/**
 * @param {string} stockCode
 */
function usePortfolioByCode(stockCode) {
  const { cb, key } = fetch(stockCode);
  const { data, isSuccess, refetch } = useQuery(key, cb, {
    enabled: !!stockCode,
  });

  // Only return the nested data
  const _data = data?.portfolio?.[0] || null;

  /**
   * Number of lots owned by the user that can be put in a new Sell order.
   * Lots currently being locked on other features cannot be sold.
   *
   * - lot              : lot owned by user
   * - sellot           : lot currently being held on an open sell order
   * - freeze_asset_lot : lot currently being held due to TP/SL
   * */
  const availableLot = (_data?.lot || 0) - ((_data?.selllot || 0) + (_data?.freeze_asset_lot || 0));

  return { data: _data, isSuccess, refetch, availableLot };
}

export default usePortfolioByCode;
